module.exports = __webpack_public_path__ + "img/flag-SWEDEN.301c8975.svg";